import { useHead } from '@unhead/vue'
import { type Ref, ref } from 'vue'
import { useRoute } from 'vue-router'

import { legalAddresses } from '@/constants/legalAddresses'

export const useLegalAddress = (): Ref<string | null> => {
  if (import.meta.env.SSR || import.meta.env.DEV) {
    const route = useRoute()

    const legalAddress = legalAddresses[route.meta.descriptor || String(route.params.descriptor || '')] ?? null

    useHead({
      meta: [
        {
          name: 'legal-address',
          content: legalAddress,
        },
      ],
    })

    return ref(legalAddress)
  }

  const legalAddressTag = document.querySelector('meta[name="legal-address"]')

  return ref(legalAddressTag?.getAttribute('content') ?? null)
}
